export const ROLES =
    [
        {
            label: "Owner / partner",
            value: "Owner",
            label_ar: "مالك / شريك",
            description: "I am a shareholder in the company.",
            description_ar: "أنا مساهم في الشركة."
        },
        {
            label: "Manager",
            value: "Manager",
            label_ar: "مدير",
            description: "I am authorised to carry out companys activities.",
            description_ar: "أنا مفوض لتنفيذ أنشطة الشركة"
        },
        {
            label: "Representative (PRO, Agent, Staff)",
            value: "Representative",
            label_ar: "ممثل (مندوب، وكيل، موظف)",
            description: "I am a representative at this company who want to apply for services on behalf of the company.",
            description_ar: "أنا موظف في هذه الشركة وأرغب في التقديم على الخدمات نيابةً عن الشركة"
        }
    ];